export default "__VITE_ASSET__FnmMZ2Nc__"